module.exports = __webpack_public_path__ + "static/media/create.239f7556.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vectors/create.svg
// module id = 522
// module chunks = 0